<template>
    <div class="image-slider">

        <div class="row" >
            <div class="col-md-12 col-lg-12 col-12 col-lg-12 px-0 vto_block" :class="{'col-md-10 col-lg-10 col-12': ['full-eternity-ring', 'anniversary-ring', 'band-ring', 'in-stock-ring'].includes(detailData.sub_type)}">
                <div class="swiper jew-detail-sw z_index" ref="swiperRef">
                    <div class="swiper-wrapper" :class="{ 'swiper-grid': !isMobile }">

                        <div v-if="images && images?.front" :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box slick-track">
                            <!-- <img width="900" height="900" :src="images.front" alt="front"> -->
                            <CommonProductZoom :width="900" :height="900" :src="images.front" alt="front"/>

                            <p v-if="detailData?.image_lot != 0 && detailData?.sub_type != 'hoop-earring'" class="for_desktop dimention_copy text-center my-3">Shown with {{ detailData.image_lot }} ct. tw. diamonds.</p>
                        </div>

                        <template v-for="(image, key) in images" :key="key">
                            <div v-if="key !=='front' && image" :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box slick-track p-md-1">
                                
                                <video v-if="image?.includes('.mp4')" :key="currentCarat.id" @contextmenu.prevent="" controlsList="nodownload" ref="video" controls width="400" height="400" autoplay loop muted playsinline>
                                    <source :src="image" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>

                                <div class="measurement"  v-else-if="['left'].includes(key) && detailData.sub_type === 'hoop-earring'" >
                                    <!-- <img 
                                        width="900" 
                                        height="900" 
                                        :src="image" 
                                    /> -->
                                    <CommonProductZoom :width="900" :height="900" :src="image" alt="left image"/>

                                    <span v-if="addtionalAttirbute" class="length">{{ addtionalAttirbute[0].average_width }}</span>
                                    <span v-if="addtionalAttirbute" class="width"> {{ addtionalAttirbute[0].length }}</span>
                                </div>

                                <!-- <img width="900" height="900" v-else :src="image" :alt="key"> -->
                                <CommonProductZoom v-else :width="900" :height="900" :src="image" :alt="key"/>
                                
                            </div>
                        </template>
                    </div>

                    <div class="jew-detail-sw-pgtn swiper-pagination"></div>
                    <p v-if="detailData?.image_lot != 0 && detailData?.sub_type != 'hoop-earring'" class="for_mobile dimention_copy text-center mb-3">Shown with {{ detailData.image_lot }} ct. tw. diamonds.</p>

                </div>
            </div>
        </div>
        
    </div>
</template>

<script setup>
 import Swiper from 'swiper';
 import { Pagination } from 'swiper/modules';

 import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';
 const store = shopdetailStore()

 const route = useRoute()

const { isMobile : isMobile } = useDevice()
const swiperRef = ref(null)


 const detailData = computed(()=> {
     return store.getDetailData
 })

 const images = computed(()=> {
     return store.getWebshopSliderImages
 })

 const title = computed(()=> {
     return store.getCurrentActive('metal').product_name
 })

 const currentCarat = computed(()=> {
     return store.getCurrentActive('carat')
 })

 const addtionalData = computed(()=> {
     return store.getAdditionalDetails
 })

 const currentSize = computed(()=> {
     return store.getActiveAttributeForSlider
 })

 const addtionalAttirbute = computed(()=> {
     let size = null
     if(currentSize.value){
         size = currentSize.value.value
     }
     else if(detailData.value.sub_type === 'hoop-earring'){

         return addtionalData.value
     }
     else if( addtionalData.value && size !== undefined  ){

         const filteredData = addtionalData.value.find( cv => cv.size_attribute == size )

         if( filteredData !== undefined ){

             return filteredData
         }
     }
     
     else if( currentCarat.value !== undefined ){

         return currentCarat.value
     } 

     else{
         return null
     }
 })

 onMounted(() =>{
     store.setAdditionalDetails({ slug: route.params.slug })

     if (isMobile) {
         new Swiper('.jew-detail-sw', {
             spaceBetween: 20,
             modules:[Pagination],
             pagination: {
                 el: '.jew-detail-sw-pgtn',
                 clickable: true,
             },
         })
     }

 })

 
onBeforeUnmount( () =>  {

    if (swiperRef?.value?.swiper?.destroy instanceof Function) {
        swiperRef?.value?.swiper?.destroy(true, true);
        console.log("Swiper instance destroyed successfully.");
    }
})

</script>

<style scoped>
.z_index{
    z-index: 0;
}
.vto_block{
    position: relative;
}
/* -------------- */
.dropdown_active_mod {
 min-width: 75px !important;
}

.shape_drop {
 position: relative;
 cursor: pointer;
}

.shape_label svg.svg-head {
 height: 13px;
}

.shape_drop ul {
 width: 100%;
 background: #fff;
 border-radius: 8px;
 box-shadow: 0 0 8px #00000026;
 right: -4px;
 max-width: 150px;
 position: absolute;
 top: 100%;
 z-index: 99;
 padding: 10px 0;
}

.shape_label {
 text-transform: capitalize;
 justify-content: space-between;
 line-height: 1.5;
 color: #000;
 vertical-align: middle;
 padding: 0 16px 0 0;
 font-size: 14px;
 cursor: pointer;
}

.label_text {
 color: #212529;
 font-size: 14px;
 font-weight: 600;
}

.dropdown_active {
 border: 1px solid #c4c4c4;
 border-radius: 8px;
 padding: 5px 0 5px 5px;
 margin-left: 8px;
 min-width: 130px;
 display: flex;
 align-items: center;
 justify-content: space-between;
 height: 40px;
}

.shape_drop ul li {
 list-style: none;
 font-size: 14px;
 padding: 4px 16px;
 text-transform: capitalize;
 color: #6a6161;
}

.shape_drop ul li.active {
 background: rgba(204, 204, 204, 0.36863);
}

.shape_drop ul li:hover {
 background: rgba(204, 204, 204, 0.36863);
}

span {
 font-size: 14px;
 color: var(--green);
}

.shape_label p {
 font-weight: 400;
}

.shape_label p span {
 font-weight: 700;
 margin-left: 5px;
}
img,
video {
 border-radius: 8px;
}

video {
 width: 100%;
 height: auto;
}

iframe {
 border-radius: 8px;
}

.swiper-grid {
 display: flex;
 flex-wrap: wrap;
}

.swiper-slide-box {
 width: 50%;   
 height: 100%;
}

.swiper-slide-box:first-child {
 width: 100%;
}

img{
 max-width:100%;
 height: auto;
}

img, video {
 border-radius: 8px;
}


iframe{
 border-radius: 8px;
}

@media(min-width:768px){
    img,
    video,
    iframe {
        border: 1px solid #f5f5f5;
    }
}

.image-slider {
 width: 100%;
 height: 100%;
}


:global(.image-slider .swiper-slide) {
 height: auto !important;
}

/* swiper pagination: mobile */
:global(.image-slider .swiper-pagination) {
 position: relative;
 
}

:global(.image-slider .swiper-pagination-bullet) {
    background: transparent !important;
    opacity: 1 !important;
    margin: 0 5px !important;
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 0 !important;
}

:global(.image-slider .swiper-pagination-bullet::before) {
    content: '';
    position: absolute;
    top: 50%;   
    left: 50%;
    transform: translate(-50%, -50%);
    z-index:   -1;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: #c4c4c4 !important;
    opacity: 1 !important;
}

:global(.image-slider .swiper-pagination-bullet-active::before) {
    background: #606060 !important;
}

@media (min-width: 768px) {
 .slick_slider_block {
     position: -webkit-sticky;
     position: sticky;
     top: 20px;
     height: -webkit-fit-content;
     height: -moz-fit-content;
     height: fit-content;
 }
}

@media(max-width: 767px) {
 .select_shape_block {
     margin: 3% 0 0;
 }

}

/*skeleton*/
.for_desktop_mod {
 display: none;
}

@media (min-width: 767px) and (max-width: 1024px) {
 .for_desktop_mod {
     display: block !important;
 }

}

.fade-enter-active,
.fade-leave-active {
 transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
 opacity: 0;
}


/* ------------ */
.measurement {
    position: relative;
}
span.length {
    position: absolute;
    bottom: 12%;
    left: 10%;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
    min-width: 65px;
    text-align: center;
    color: #353535;
}
span.width {
    position: absolute;
    left: -40px;
    top: 48%;
    transform: rotate(-90deg);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    min-width: 120px;
    text-align: center;
    color: #353535;
}

@media(max-width: 1200px){
    span.length {
        bottom: 11%;
    }
    span.width {
        left: -48px;
    }
}
@media(max-width: 767px){
    span.length {
        bottom: 12%;
    }
    span.width {
        left: -40px;
    }
}
/* ------------ */
</style>